const Backbone = require('backbone');
const Nunjucks = require('view');
const UniqId = require('uniqid');
const template = require('./tr-produto.twig');

const View = Backbone.View.extend({
	tagName: 'tr',
	initialize: function(config) {
		var that = this;

		that.config = config;

		that.porcoes = new Backbone.Collection(that.model.get('porcoes'));
		that.porcao = new Backbone.Model(that.porcoes.at(0).toJSON());

		that.listenTo(that.model, 'change', that.render);
		that.listenTo(that.porcao, 'change:calorias', that.setCalorias);
		that.listenTo(that.porcao, 'change:valor', that.setValor);
		that.listenTo(that.porcao, 'change:valor_promocional', that.setValor);
		that.listenTo(that.model, 'change:promocao', that.setValor);

		that.listenTo(that.model, 'remove', that.remove);


		that.render();
	},
	events: {
		'change [name=porcao_id]': 'setProcao',
		'click .add-product': 'addProduto'
	},
	addProduto: function() {
		var that = this;

		that.config.CardapioAtual.add({
			id: UniqId(),
			//id: that.porcao.get('id'),
			porcao_id: that.porcao.get('id'),
			calorias: that.porcao.get('calorias'),
			
			estoque: that.porcao.get('estoque'),
			produto: that.model.get('titulo'),
			promocao: that.model.get('promocao'),
			
			porcao: that.porcao.get('titulo'),
			titulo: that.porcao.get('titulo'),
			valor: that.porcao.get('valor'),
			valor_promocional: that.porcao.get('valor_promocional')
		});
	},
	setCalorias: function() {
		var that = this;
		
		that.$calorias.html(Math.round(that.porcao.get('calorias')));
	},
	setValor: function() {
		var that = this;
		var valor = that.porcao.get('valor');
		if (that.model.get('promocao')) {
			valor = that.porcao.get('valor_promocional');
		}
		valor = (valor+'').number_format(2,',','.');
		that.$valor.html(valor);
	},
	setProcao: function(e) {
		var that = this;
		var $select = that.$el.find(e.currentTarget);
		var porcao_id = $select.val()|0;
		var porcao = that.porcoes.get(porcao_id);

		that.porcao.set(porcao.toJSON());


	},
	render: function() {
		var that = this;

		var data = that.model.toJSON();
		data.Porcao = that.porcao.toJSON();

		var html =  Nunjucks.renderString(template, data)

		that.$el.html(html);
		that.$calorias = that.$el.find('.calorias');
		that.$valor = that.$el.find('.valor');
		that.setCalorias();
		that.setValor();
		

	}
});

module.exports = View;



//////////////////
// WEBPACK FOOTER
// ./views/kits/dialog-cardapio/tr-produto.js
// module id = 46
// module chunks = 0